import { gql } from '@apollo/client';

export const Tag = gql`
    fragment tagFragment on tag {
        id
        title
    }
`;
